import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Tooltip, IconButton} from '@material-ui/core';
import {Edit as EditIcon} from '@material-ui/icons';
import {
  FilteringState,
  IntegratedFiltering,
  IntegratedSorting,
  SortingState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import {useWindowResize} from '@ozgene/gp5.hooks.use-window-resize';
import {sortByProperty} from '@ozgene/gp5.utils.sort-functions';
import CustomTableLoading from 'Utility/CustomTableLoading';
import {ColumnDefinedFilterCell} from 'Components/ColumnDefinedFilterCell';
import {CustomRowComponent} from 'Components/CustomRowComponent';

const columnExtensions = [
  {columnName: 'actions', sortingEnabled: false, filteringEnabled: false},
];
const metricUnitColumnExtensions = [{columnName: 'actions', width: 95}];

export default function MetricUnitList(props) {
  const {metricUnits, onEditMetricUnit} = props;
  const {height} = useWindowResize();
  const [isLoading, setIsLoading] = useState(true);
  const integratedSortingColumnExtensions = [
    {
      columnName: 'name',
      compare: sortByProperty((x) => x),
    },
  ];
  const getActionColumn = (row) => (
    <Tooltip title="Edit Consumable">
      <IconButton
        size="small"
        color="primary"
        onClick={() => onEditMetricUnit(row)}
      >
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
  const metricUnitColumns = [
    {
      name: 'name',
      title: 'Name',
      getCellValue: (row) => row.name,
    },
    {
      name: 'actions',
      title: 'Actions',
      getCellValue: getActionColumn,
      CustomCellFilterComponent: false,
    },
  ];

  useEffect(() => {
    if (metricUnits.length > 0) {
      setIsLoading(false);
    }
  }, [metricUnits]);

  return !isLoading ? (
    <Grid rows={metricUnits} columns={metricUnitColumns}>
      <FilteringState columnExtensions={columnExtensions} />
      <SortingState columnExtensions={columnExtensions} />
      <IntegratedFiltering />
      <IntegratedSorting columnExtensions={integratedSortingColumnExtensions} />
      <VirtualTable
        height={height - 130}
        columnExtensions={metricUnitColumnExtensions}
        rowComponent={CustomRowComponent}
      />
      <TableHeaderRow showSortingControls />
      <TableFilterRow
        showFilterSelector={true}
        cellComponent={ColumnDefinedFilterCell}
      />
    </Grid>
  ) : (
    <CustomTableLoading />
  );
}

MetricUnitList.propTypes = {
  metricUnits: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  onEditMetricUnit: PropTypes.func.isRequired,
};
